import React, { ReactNode, createContext, useState } from 'react'
import getConfig from 'next/config'
import DefaultLayout, {
  LayoutSpacingOptions,
} from '@src/components/DefaultLayout'
import SelectDtaqDealerModal from '@src/components/SelectDtaqDealerModal'
import { useCurrentUser } from '@utils/useCurrentUser'
import messages from '../../messages'

import ConfiguratorPageError from '../../utils/ConfiguratorPageError'

import { useRouter } from '@src/routes'

import {
  checkForRedesignedBiTubeProduct,
  useProductFromQueryParam,
} from '../../products/TubesMTORedesign/ProductsConfiguration'
const {
  publicRuntimeConfig: { featureFlags },
} = getConfig()
interface ConfiguratorDefaultLayoutProps {
  className?: string
  style?: React.CSSProperties
  spacing?: LayoutSpacingOptions
  children: ReactNode
}

interface ButtonText {
  id: string
  defaultMessage: string
}

interface DealerModalContextInterface {
  btnTextOverride?: ButtonText
  isDealerModalOpen: boolean
  onDealerSelect?: (selectedDealerId: string | null) => void
  setOnDealerSelectCallback: (callback: () => void) => void
  setIsDealerModalOpen: (boolean) => void
}

export const DealerModalContext = createContext<DealerModalContextInterface>({
  isDealerModalOpen: false,
  setIsDealerModalOpen: () => {
    // Added comment for avoid es-lint error
  },
  setOnDealerSelectCallback: () => null,
})

const ConfiguratorDefaultLayout: React.FC<ConfiguratorDefaultLayoutProps> = ({
  spacing = LayoutSpacingOptions.NONE,
  children,
}) => {
  const { isDTAQZuCustomer } = useCurrentUser()
  const showPreferredDealerSection =
    featureFlags.dealerCartEnabled && isDTAQZuCustomer
  const [isDealerModalOpen, setIsDealerModalOpen] = useState(false)
  const [onDealerSelectCallback, setOnDealerSelectCallback] = useState<
    () => void
  >(() => null)
  const router = useRouter()
  const { userIsLoggedIn } = useCurrentUser()
  const product = useProductFromQueryParam()
  const isBiTubeProduct = checkForRedesignedBiTubeProduct(product)
  const countryCode = router?.query?.country ?? ''
  const productCode =
    isBiTubeProduct && countryCode === 'JP' && !userIsLoggedIn ? 1 : 0
  if (productCode === 1)
    return (
      <DefaultLayout spacing={LayoutSpacingOptions.MD}>
        <ConfiguratorPageError
          productCode={productCode}
          country={countryCode}
        />
      </DefaultLayout>
    )

  return (
    <DefaultLayout spacing={spacing}>
      <DealerModalContext.Provider
        value={{
          isDealerModalOpen,
          setIsDealerModalOpen,
          setOnDealerSelectCallback,
        }}
      >
        {children}
      </DealerModalContext.Provider>
      {showPreferredDealerSection && (
        <SelectDtaqDealerModal
          btnTextOverride={messages.SET_AS_PREFERRED_DEALER}
          open={isDealerModalOpen}
          onClose={() => setIsDealerModalOpen(false)}
          onDealerSelectCallback={onDealerSelectCallback}
          disabled={false}
          onSearch={() => console.info('🚧: Feature under construction')}
        />
      )}
    </DefaultLayout>
  )
}

export default ConfiguratorDefaultLayout
